import { gql } from '@apollo/client';

const CONVERT_INVESTOR_MATCH = gql`
  mutation convertInvestorMatchToStandardLead($params: ConvertInvestorMatchToStandardLeadParams!) {
    convertInvestorMatchToStandardLead(params: $params)
  }
`;

export default CONVERT_INVESTOR_MATCH;
